/**
 * Vietnamese is the source of truth (ADR-A20). `en.ts` must mirror every key;
 * `i18n.test.ts` enforces parity and placeholder parity. Placeholders: {name}.
 */
export const vi = {
  // ---- brand / nav
  "app.name": "Yabe",
  "app.tagline": "Bán mà không cần định giá.",
  "nav.home": "Trang chủ",
  "nav.browse": "Khám phá",
  "nav.sell": "Đăng bán",
  "nav.watching": "Theo dõi",
  "nav.me": "Tôi",
  "nav.notifications": "Thông báo",
  "nav.settings": "Cài đặt",
  "nav.login": "Đăng nhập",
  "nav.logout": "Đăng xuất",
  "nav.admin": "Quản trị",

  // ---- generic
  "common.ok": "OK",
  "common.cancel": "Huỷ",
  "common.close": "Đóng",
  "common.save": "Lưu",
  "common.confirm": "Xác nhận",
  "common.back": "Quay lại",
  "common.next": "Tiếp",
  "common.done": "Xong",
  "common.retry": "Thử lại",
  "common.copy": "Sao chép",
  "common.copied": "Đã sao chép",
  "common.share": "Chia sẻ",
  "common.loading": "Đang tải…",
  "common.search": "Tìm kiếm",
  "common.filter": "Bộ lọc",
  "common.all": "Tất cả",
  "common.new": "Mới",
  "common.yes": "Có",
  "common.no": "Không",
  "common.more": "Xem thêm",
  "common.less": "Thu gọn",
  "common.since": "thành viên từ {year}",
  "common.language": "Ngôn ngữ",
  "common.theme": "Giao diện",
  "common.theme.system": "Theo hệ thống",
  "common.theme.light": "Sáng",
  "common.theme.dark": "Tối",

  // ---- errors
  "error.generic": "Có lỗi xảy ra. Thử lại nhé.",
  "error.network": "Mất kết nối. Kiểm tra mạng và thử lại.",
  "error.not_found": "Không tìm thấy trang này.",
  "error.unauthorized": "Bạn cần đăng nhập.",
  "error.forbidden": "Bạn không có quyền làm việc này.",
  "error.rate_limited": "Bạn thao tác quá nhanh. Đợi một chút rồi thử lại.",
  "error.validation": "Thông tin chưa hợp lệ.",
  "error.invalid_phone": "Số điện thoại không hợp lệ.",
  "error.invalid_code": "Mã không đúng.",
  "error.code_expired": "Mã đã hết hạn. Gửi lại mã mới.",
  "error.too_many_attempts": "Sai quá nhiều lần. Gửi lại mã mới.",
  "error.phone_blocked": "Số này không thể dùng để đăng ký.",
  "error.invalid_handle": "Tên người dùng chỉ gồm chữ thường, số và dấu gạch dưới, 3–20 ký tự.",
  "error.handle_taken": "Tên người dùng này đã có người dùng.",
  "error.handle_cooldown": "Bạn chỉ có thể đổi tên người dùng 90 ngày một lần.",
  "error.reserved_handle": "Tên người dùng này không được phép.",
  "error.invalid_invite": "Mã mời không đúng hoặc đã dùng.",
  "error.suspended": "Tài khoản đang tạm khoá.",
  "error.banned": "Tài khoản đã bị khoá.",

  // ---- auth
  "auth.phone.title": "Số điện thoại của bạn",
  "auth.phone.hint": "Chúng tôi sẽ gửi mã 6 số qua SMS. Không cần mật khẩu.",
  "auth.phone.submit": "Gửi mã",
  "auth.otp.title": "Nhập mã 6 số",
  "auth.otp.sent_to": "Đã gửi tới {phone}",
  "auth.otp.resend": "Gửi lại mã",
  "auth.otp.resend_in": "Gửi lại sau {seconds}s",
  "auth.otp.change_phone": "Đổi số",
  "auth.onboard.title": "Chào bạn mới",
  "auth.onboard.display_name": "Tên hiển thị",
  "auth.onboard.handle": "Tên người dùng",
  "auth.onboard.handle_hint": "yabe.io/u/{handle}",
  "auth.onboard.terms": "Tôi đồng ý với",
  "auth.onboard.terms_link": "Điều khoản",
  "auth.onboard.prohibited_link": "Danh mục cấm bán",
  "auth.onboard.submit": "Bắt đầu",
  "auth.state.suspended":
    "Tài khoản của bạn đang tạm khoá vì có 3 lỗi trong 90 ngày. Quản trị viên sẽ xem xét.",
  "auth.state.banned": "Tài khoản này đã bị khoá.",
  "auth.state.deleting": "Tài khoản đang chờ xoá. Dữ liệu sẽ được ẩn danh sau 14 ngày.",

  // ---- price / listing
  "price.rule": "Giá giảm liên tục đến khi có người mua. Không ai thấy giá sàn.",
  "price.start": "Giá khởi điểm",
  "price.current": "Giá hiện tại",
  "price.floor": "Giá sàn",
  "price.floor.none": "Không có sàn — để thị trường quyết định. Món tốt hiếm khi về 0.",
  "price.floor.set": "Giá dừng giảm ở {price}. Người mua không thấy con số này.",
  "bucket.ending_soon": "Sắp kết thúc",
  "bucket.hours": "Còn vài giờ",
  "bucket.under_day": "Còn dưới 1 ngày",
  "bucket.days": "Còn vài ngày",
  "counts.watching": "{n} đang xem",
  "counts.alerts": "{n} báo giá",
  "listing.status.draft": "Nháp",
  "listing.status.scheduled": "Sắp lên",
  "listing.status.active": "Đang bán",
  "listing.status.sold_out": "Đã bán",
  "listing.status.expired": "Hết hạn",
  "listing.status.cancelled": "Đã huỷ",
  "listing.condition.new": "Mới",
  "listing.condition.like_new": "Như mới",
  "listing.condition.good": "Tốt",
  "listing.condition.fair": "Tạm",
  "listing.drop_tag": "Drop",
  "listing.qty_remaining": "Còn {n}",
  "listing.similar": "Xem món tương tự",
  "listing.under_review": "Đang được xem xét",
  "listing.starts_at_drop": "Bắt đầu {when}",
  "listing.report": "Báo cáo",

  // ---- drop
  "drop.next": "Drop tiếp theo · {when}",
  "drop.this_week": "Drop tuần này",
  "drop.live_now": "Đang bán",
  "drop.queued": "{n} món đang chờ",
  "drop.countdown": "{d}n {h}g {m}p",
  "drop.time_label": "T7 20:00",
  "drop.reminder.title": "Drop bắt đầu sau 1 giờ",
  "drop.reminder.body": "{n} món sẽ lên sàn lúc 20:00.",
  "drop.start.title": "Drop đã bắt đầu",
  "drop.start.body": "{n} món vừa lên sàn. Giá đang giảm.",

  // ---- buy
  "buy.cta": "Mua ngay",
  "buy.quantity": "Số lượng",
  "buy.total": "Tổng",
  "buy.confirm.note": "Giá có thể đã giảm thêm khi bạn xác nhận — bạn trả giá thấp hơn.",
  "buy.confirm.cta": "Xác nhận mua",
  "buy.success": "Đã mua. Chờ @{seller} chia sẻ liên hệ — thường trong {hours} giờ.",
  "buy.sold_out": "Vừa hết hàng.",
  "buy.ended": "Món này đã kết thúc.",
  "buy.own_listing": "Bạn không thể mua món của chính mình.",
  "buy.open_cap": "Bạn đang có 3 giao dịch chưa xong. Hoàn tất trước khi mua thêm.",
  "buy.open_problem": "Bạn đang có vấn đề chưa giải quyết với người bán này.",
  "buy.login_required": "Đăng nhập bằng số điện thoại để mua.",

  // ---- alerts / watch
  "alert.watch": "Theo dõi",
  "alert.watching": "Đang theo dõi",
  "alert.set": "Đặt báo giá",
  "alert.target": "Mục tiêu {price} · còn {pct}",
  "alert.set.done": "Bạn sẽ được báo khi giá chạm {price}.",
  "alert.reached": "{title} đã chạm giá của bạn: {price}. Mua trước khi người khác mua.",
  "alert.reached.short": "Đã chạm giá của bạn",
  "alert.sheet.hint": "Bạn sẽ được báo khi giá chạm mức này.",
  "alert.sheet.watch_only": "Chỉ theo dõi, không đặt giá",
  "alert.remove": "Bỏ theo dõi",

  // ---- purchase
  "purchase.status.pending_contact": "Chờ liên hệ",
  "purchase.status.contact_shared": "Đã chia sẻ",
  "purchase.status.completed": "Hoàn tất",
  "purchase.status.cancelled": "Đã huỷ",
  "purchase.timeline.bought": "Đã mua",
  "purchase.timeline.waiting": "Chờ người bán chia sẻ liên hệ (tối đa 24 giờ)",
  "purchase.timeline.shared": "Đã chia sẻ liên hệ",
  "purchase.timeline.completed": "Hoàn tất",
  "purchase.usual_response": "Thường chia sẻ liên hệ trong {hours} giờ",
  "purchase.max_response": "Tối đa 24 giờ",
  "purchase.deadline_left": "Còn {hours} giờ",
  "purchase.share_contact": "Chia sẻ liên hệ",
  "purchase.contact.shared": "Đã chia sẻ liên hệ. Hẹn gặp và đưa mã giao dịch khi nhận hàng.",
  "purchase.call": "Gọi",
  "purchase.zalo": "Nhắn Zalo",
  "purchase.mark_done": "Đánh dấu xong",
  "purchase.confirm_done": "Xác nhận đã xong",
  "purchase.report_problem": "Báo vấn đề",
  "purchase.cancel": "Huỷ",
  "cancel.warning":
    "Huỷ sẽ tính 1 lỗi vắng mặt vào tài khoản của bạn. 3 lỗi trong 90 ngày sẽ tạm khoá tài khoản.",
  "deal.code": "Mã giao dịch",
  "deal.code.hint": "Đưa mã này cho người bán khi nhận hàng.",
  "deal.enter": "Nhập mã giao dịch người mua đưa cho bạn.",
  "deal.enter.cta": "Nhập mã giao dịch",
  "deal.wrong": "Mã không đúng. Còn {n} lần thử.",
  "deal.locked": "Nhập sai 5 lần. Thử lại sau 1 giờ.",
  "deal.completed": "Giao dịch hoàn tất.",
  "invite.ask": "Muốn bán? Xin lời mời từ @{seller}",
  "invite.ask.cta": "Xin lời mời",
  "invite.ask.sent": "Đã gửi yêu cầu.",

  // ---- problems
  "problem.title": "Báo vấn đề",
  "problem.reason.seller_no_show": "Người bán không đến",
  "problem.reason.item_not_as_described": "Món không như mô tả",
  "problem.reason.buyer_no_show": "Người mua không đến",
  "problem.reason.payment_not_received": "Chưa nhận được tiền",
  "problem.reason.other": "Khác",
  "problem.note": "Mô tả",
  "problem.images": "Ảnh (tối đa 3)",
  "problem.filed": "Đã gửi. Quản trị viên sẽ xem xét.",
  "problem.reply": "Phản hồi",
  "problem.replied": "Đã phản hồi.",
  "problem.open_badge": "Có vấn đề",

  // ---- profile / trust
  "profile.sold": "Đã bán {n}",
  "profile.sell_through": "Tỷ lệ bán {pct} (6 tháng)",
  "profile.share_time": "Chia sẻ liên hệ trong ~{hours} giờ",
  "profile.bought": "Đã mua {n}",
  "seller.new": "Người bán mới",
  "buyer.reliable": "Người mua đáng tin",
  "buyer.new": "Mới",
  "buyer.noshows": "{n} lần vắng mặt trong 90 ngày",
  "user.deleted": "[đã xoá]",
  "profile.strikes": "Lỗi đang tính",
  "profile.strike.expires": "hết hạn {date}",
  "profile.active_listings": "Đang bán",
  "profile.seller_cancels": "đã huỷ {n} món đang bán trong 90 ngày",

  // ---- sell form
  "sell.title": "Đăng bán",
  "sell.step.photos": "Ảnh",
  "sell.step.details": "Chi tiết",
  "sell.step.location": "Địa điểm",
  "sell.step.price": "Giá",
  "sell.step.time": "Thời gian",
  "sell.step.review": "Xem lại",
  "sell.photos.hint": "Kéo để sắp xếp. Ảnh đầu là ảnh bìa.",
  "sell.field.title": "Tiêu đề",
  "sell.field.category": "Danh mục",
  "sell.field.condition": "Tình trạng",
  "sell.field.description": "Mô tả",
  "sell.field.city": "Thành phố",
  "sell.field.district": "Quận",
  "sell.field.quantity": "Số lượng",
  "sell.field.start_price": "Giá khởi điểm",
  "sell.field.floor_price": "Đặt giá sàn",
  "sell.field.duration": "Thời gian giảm",
  "sell.duration.h6": "6 giờ",
  "sell.duration.h6.drop_only": "6 giờ chỉ trong Drop",
  "sell.duration.h24": "24 giờ",
  "sell.duration.d3": "3 ngày",
  "sell.duration.d7": "7 ngày",
  "sell.start.drop": "Drop {when}",
  "sell.start.drop.queued": "{n} món đã xếp hàng cho Drop này",
  "sell.start.now": "Bắt đầu ngay",
  "sell.preview": "Người mua sẽ thấy như thế này (không có giá sàn)",
  "sell.publish": "Đăng",
  "sell.published.drop": "Đã xếp hàng. Lên sàn {when}.",
  "sell.published.now": "Đã đăng. Giá bắt đầu giảm.",
  "sell.cap_reached": "Bạn đang có 30 món đang bán hoặc sắp lên. Kết thúc bớt trước khi đăng thêm.",
  "sell.drafts_cap": "Tối đa 10 bản nháp.",
  "sell.need_invite": "Cần lời mời từ người bán để đăng bán.",
  "sell.lower_floor": "Hạ giá sàn",
  "sell.cancel_listing": "Huỷ",
  "sell.cancel_listing.confirm":
    "Huỷ món đang bán? Số lượng còn lại sẽ bị bỏ; các giao dịch đã mua vẫn phải hoàn tất.",
  "sell.relist": "Đăng lại",
  "sell.tabs.active": "Đang bán",
  "sell.tabs.scheduled": "Sắp lên (Drop)",
  "sell.tabs.drafts": "Nháp",
  "sell.tabs.ended": "Đã kết thúc",
  "sell.ladder": "Bảng báo giá",
  "sell.ladder.hint": "Người mua đang chờ ở các mức này (ẩn danh).",
  "sell.ladder.min": "Hiện khi có từ 3 báo giá.",

  // ---- browse / home
  "home.guest_cta": "Muốn bán? Cần lời mời từ người bán.",
  "browse.tab.live": "Đang bán",
  "browse.tab.next_drop": "Drop tới",
  "browse.sort.default": "Sắp kết thúc",
  "browse.sort.newest": "Mới nhất",
  "browse.sort.price_asc": "Giá thấp → cao",
  "browse.sort.price_desc": "Giá cao → thấp",
  "browse.results": "{n} món",
  "empty.browse": "Sàn đang yên ắng. Drop tiếp theo T7 20:00.",
  "empty.watching": "Chưa theo dõi món nào. Đặt báo giá để được gọi khi giá về mức bạn muốn.",
  "empty.listings": "Chưa có món nào. Có gì đang nằm không? Để thị trường định giá.",
  "empty.purchases": "Chưa mua món nào.",
  "empty.sales": "Chưa bán món nào.",
  "empty.notifications": "Chưa có thông báo.",
  "empty.search": "Không có món nào khớp với “{q}”.",

  // ---- report listing
  "report.title": "Báo cáo tin đăng",
  "report.reason.prohibited": "Hàng cấm",
  "report.reason.counterfeit": "Hàng giả",
  "report.reason.misleading": "Mô tả sai",
  "report.reason.spam": "Spam",
  "report.reason.other": "Khác",
  "report.sent": "Đã gửi báo cáo.",

  // ---- notifications
  "notif.title": "Thông báo",
  "notif.mark_all": "Đánh dấu tất cả đã đọc",
  "notif.purchase_received.title": "@{buyer} vừa mua {title}",
  "notif.purchase_received.body": "{qty} × {price}. Chia sẻ liên hệ trong 24 giờ.",
  "notif.contact_shared.title": "@{seller} đã chia sẻ liên hệ",
  "notif.contact_shared.body": "Hẹn gặp và đưa mã giao dịch khi nhận hàng.",
  "notif.alert_reached.title": "{title} đã chạm giá của bạn",
  "notif.alert_reached.body": "{price}. Mua trước khi người khác mua.",
  "notif.watch_ending_soon.title": "{title} sắp kết thúc",
  "notif.watch_ending_soon.body": "Còn dưới 1 giờ. Giá hiện tại {price}.",
  "notif.watch_sold_out.title": "{title} đã bán",
  "notif.watch_sold_out.body": "Món bạn theo dõi vừa có người mua.",
  "notif.watch_floor_lowered.title": "Người bán đã hạ giá sàn",
  "notif.watch_floor_lowered.body": "{title} sẽ giảm sâu hơn.",
  "notif.done_requested.title": "@{other} đánh dấu đã xong",
  "notif.done_requested.body": "Xác nhận hoặc báo vấn đề trong 48 giờ.",
  "notif.purchase_completed.title": "Giao dịch hoàn tất",
  "notif.purchase_completed.body": "{title} · {price}",
  "notif.purchase_cancelled.title": "Giao dịch đã huỷ",
  "notif.purchase_cancelled.body": "{title} · {reason}",
  "notif.problem_filed.title": "@{other} đã báo vấn đề",
  "notif.problem_filed.body": "{reason}. Bạn có thể phản hồi một lần.",
  "notif.problem_replied.title": "@{other} đã phản hồi",
  "notif.problem_replied.body": "Quản trị viên sẽ xem xét.",
  "notif.problem_resolved.title": "Vấn đề đã được giải quyết",
  "notif.problem_resolved.body": "{note}",
  "notif.strike_issued.title": "Bạn bị tính 1 lỗi",
  "notif.strike_issued.body": "{reason}. Lỗi hết hạn sau 90 ngày. 3 lỗi sẽ tạm khoá tài khoản.",
  "notif.account_suspended.title": "Tài khoản tạm khoá",
  "notif.account_suspended.body": "3 lỗi trong 90 ngày. Quản trị viên sẽ xem xét.",
  "notif.invite_requested.title": "@{buyer} xin lời mời bán",
  "notif.invite_requested.body": "Chấp nhận sẽ dùng 1 mã mời của bạn.",
  "notif.invite_granted.title": "Bạn đã là người bán",
  "notif.invite_granted.body": "@{seller} đã mời bạn. Đăng món đầu tiên nào.",
  "notif.open": "Mở",
  "notif.drop_reminder.title": "Drop bắt đầu sau 1 giờ",
  "notif.drop_reminder.body": "{n} món sẽ lên sàn lúc 20:00.",
  "notif.drop_start.title": "Drop đã bắt đầu",
  "notif.drop_start.body": "{n} món vừa lên sàn. Giá đang giảm.",
  "notif.admin_suspended.title": "@{handle} vừa bị tạm khoá",
  "notif.admin_suspended.body": "{n} lỗi đang tính. Gỡ khoá hoặc khoá vĩnh viễn trong Quản trị.",

  // ---- settings
  "settings.title": "Cài đặt",
  "settings.profile": "Hồ sơ",
  "settings.phone": "Điện thoại",
  "settings.phone.change": "Đổi số điện thoại",
  "settings.devices": "Thiết bị",
  "settings.devices.this": "Thiết bị này",
  "settings.devices.revoke": "Đăng xuất",
  "settings.devices.revoke_all": "Đăng xuất mọi thiết bị khác",
  "settings.notifications": "Thông báo",
  "settings.telegram.link": "Liên kết Telegram",
  "settings.telegram.linked": "Đã liên kết Telegram",
  "settings.telegram.unlink": "Huỷ liên kết",
  "settings.drop_reminders": "Nhắc Drop hàng tuần",
  "settings.become_seller": "Trở thành người bán",
  "settings.invite.enter": "Nhập mã mời",
  "settings.invite.redeem": "Kích hoạt",
  "settings.seller.status": "Bạn đã là người bán · {n} lời mời còn lại",
  "settings.invite.codes": "Mã mời của bạn",
  "settings.invite.topup": "Nạp lại 3 mã mỗi thứ Hai.",
  "settings.auto_share": "Tự động chia sẻ liên hệ",
  "settings.auto_share.hint":
    "Người mua thấy số của bạn ngay khi mua. Chỉ dành cho người bán đã hoàn tất 3 giao dịch và không có lỗi.",
  "settings.delete": "Xoá tài khoản",
  "settings.delete.warning":
    "Món đang bán sẽ bị huỷ, giao dịch chưa xong sẽ bị huỷ và tính lỗi. Dữ liệu ẩn danh sau 14 ngày. Số này không đăng ký lại được.",
  "settings.delete.confirm": "Xoá vĩnh viễn",
  "settings.export.hint": "Cần bản sao dữ liệu? Email cho chúng tôi.",
  "settings.email": "Email (tuỳ chọn)",
  "settings.city": "Thành phố",
  "settings.district": "Quận",
  "profile.as_seller": "Người bán",
  "profile.as_buyer": "Người mua",
  "notif.telegram.linked": "Đã liên kết Telegram với Yabe. Bạn sẽ nhận thông báo ở đây.",
  "notif.telegram.stopped": "Đã tắt thông báo Telegram. Bật lại trong Cài đặt.",
  "notif.telegram.unknown": "Mở Yabe → Cài đặt → Liên kết Telegram để bắt đầu.",
  "sms.purchase_received":
    "Yabe: @{buyer} vua mua {title} ({qty} x {price}). Chia se lien he trong 24 gio: {url}",
  "settings.invite.redeemed": "Bạn đã là người bán. Đăng món đầu tiên nào.",
  "settings.invite.link": "Gửi link này cho người bạn muốn mời:",
  "settings.invite.used_by": "@{handle} đã dùng",
  "settings.saved": "Đã lưu.",
  "settings.phone.new": "Số điện thoại mới",
  "settings.phone.current": "Số hiện tại",
  "settings.devices.last_seen": "Hoạt động {when}",
  "settings.handle.cooldown": "Có thể đổi lại từ {date}.",
  "settings.delete.confirm_title": "Xoá tài khoản?",

  // ---- legal
  "legal.terms": "Điều khoản sử dụng",
  "legal.privacy": "Chính sách bảo mật",
  "legal.prohibited": "Danh mục cấm bán",
  "legal.reaccept": "Điều khoản đã cập nhật. Vui lòng đọc và đồng ý để tiếp tục.",
  "legal.version": "Phiên bản {version}",

  // ---- time
  "time.now": "vừa xong",
  "time.minutes_ago": "{n} phút trước",
  "time.hours_ago": "{n} giờ trước",
  "time.days_ago": "{n} ngày trước",
  "time.weekday.6": "T7",
  "time.weekday.0": "CN",

  // ---- footer
  "footer.support": "Nhóm hỗ trợ",
  "footer.made_in": "Làm tại Sài Gòn",
} as const;

export type MessageKey = keyof typeof vi;
